module.exports = __webpack_public_path__ + "static/media/press-yahoo@3x.652065d5.jpg";